<template>
    <div>
        <!-- 日志弹窗 -->
        <van-popup v-model="showLog" position="bottom" :style="{ height: '60%', backgroundColor: '#f0f2f1' }" id="logList">
            <van-sticky>
                <div class="boxTitle">
                <van-row type="flex" justify="center" align="center">
                    <van-col span="24" align="center">日志详情</van-col>
                </van-row>
                </div>
            </van-sticky>
            <div class="logTable" style="height: calc(100% - 1rem); overflow-y: auto">
                <div class="no-con" v-if="logList.length == 0">暂无数据</div>
                <div class="logBox" v-for="(item, index) in logList" :key="index">
                <van-row type="flex" justify="center" align="center">
                    <van-col span="10">{{ item.editUser }}</van-col>
                    <van-col span="10">{{ item.editTime }}</van-col>
                </van-row>
                <van-row type="flex" justify="center" align="center">
                    <van-col span="20">{{ item.recordType }}</van-col>
                </van-row>
                <van-row type="flex" justify="center" align="center">
                    <van-col span="20">{{ item.detailInfo }}</van-col>
                </van-row>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    props: {
        logList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            showLog: false
        }
    },
    watch() {
    },
    created() {
    },
    methods: { 
        show() {
            this.showLog = true
        }
    }
}
</script>
<style lang="scss" scoped>
.boxTitle {
    height: 1rem;
    line-height: 1rem;
    background-color: #4494f3;
    color: #ffffff;
    font-size: px2rem(36);
}
.logTable {
    height: calc(100% - 1rem);
    .no-con {
      color: #3e3e3e;
      font-size: px2rem(36);
      text-align: center;
      margin: 0 auto;
      padding: 2rem 0;
    }
  }
  .logBox {
    margin: px2rem(20) px2rem(15);
    padding: 0.1rem 0;
    padding-bottom: 0.35rem;
    background-color: #fff;
    font-size: px2rem(36);
    /deep/.van-row {
      margin-top: 0.15rem;
    }
}
</style>